const impressoesForm = document.querySelector("#impressoesForm");
const firstPage = document.querySelector(".prints-form.firstPage");
const secondPage = document.querySelector(".prints-contact-form.secondPage");

class Autocomplete {
    constructor(
        container,
        input,
        optionsContainer,
        clearButton,
        options,
    ) {
        this.options = options;
        this.filteredOptions = options;

        this.container = container;
        this.input = input;
        this.optionsContainer = optionsContainer;
        this.clearButton = clearButton;

        this.selectedOption = null;

        
        this.boundRenderOptions = () => this.renderOptions();
        this.boundFilterOptions = () => this.filterOptions();
        this.boundHandleKeydown = (e) => this.handleKeydown(e);
        this.boundClear = () => this.clear();
        this.boundHandleOutsideClick = (e) => this.handleOutsideClick(e);
        this.boundDestroy = () => this.destroy();

        this.input.addEventListener("focus", this.boundRenderOptions);
        this.input.addEventListener("input", this.boundFilterOptions);
        this.input.addEventListener("keydown", this.boundHandleKeydown);

        this.clearButton.addEventListener("click", this.boundClear);

        document.addEventListener("click", this.boundHandleOutsideClick);
        window.addEventListener("resize", this.boundPositionDropdown);

        // remove event listeners to prevent memory leaks
        window.addEventListener("beforeunload", this.boundDestroy);
    }

    renderOptions() {
        // clear previous options
        this.optionsContainer.innerHTML = "";

        this.filteredOptions.forEach(option => {
            const div = document.createElement("div");

            div.dataset.id = option.value;
            div.textContent = option.label;
            div.classList.add("autocomplete-option");

            div.role = "option";

            if (option.value === this.selectedOption) {
                div.classList.add("selected");
            }

            div.addEventListener("click", () => this.selectOption(option))

            this.optionsContainer.appendChild(div);
        });

        if (!this.filteredOptions.length) {
            const div = document.createElement("div");
            div.classList.add("autocomplete-option");
            div.classList.add("no-option");
            div.textContent = "Nenhuma loja encontrada";
            this.optionsContainer.appendChild(div);
        }

        this.showDropdown();
    }

    addOptionsToSelect() {
    }

    filterOptions() {
        const filter = this.input.value.toLowerCase();

        this.filteredOptions = this.options.filter((item) => {
            return item.label.toLowerCase().includes(filter);
        });

        this.renderOptions();
    }

    selectOption(option, close = true) {
        this.selectedOption = option?.value || null;

        this.input.value = option?.label || '';
        this.input.dataset.value = option?.value || null;

        this.clearButton.classList.toggle("hidden", !this.selectedOption);

        if (!close) {
            return;
        }

        this.closeDropdown();
        this.resetFilter();
        this.input.blur();
    }

    closeDropdown() {
        this.optionsContainer.classList.toggle("hidden", true);
        this.optionsContainer.ariaExpanded = false;
    }

    showDropdown() {
        this.optionsContainer.classList.toggle("hidden", false);
        this.optionsContainer.ariaExpanded = true;
    }

    resetFilter() {
        this.filteredOptions = this.options;
    }

    clear() {
        this.selectOption(null);
    }

    handleOutsideClick(e) {
        if (!this.input.contains(e.target) && !this.container.contains(e.target)) {
            this.closeDropdown()
        }
    }

    handleKeydown(e) {
        if (!['ArrowDown', 'ArrowUp', 'Enter', 'Escape'].includes(e.key)) {
            return;
        }

        e.preventDefault();
        const items = this.optionsContainer.querySelectorAll('.autocomplete-option');

        if (!items.length) {
            return;
        }

        let index = Array.from(items).findIndex(item => item.classList.contains('highlight'));

        if (e.key === 'ArrowDown') {
            if (index >= 0) items[index].classList.remove('highlight');
            index = (index + 1) % items.length;
        } else if (e.key === 'ArrowUp') {
            if (index >= 0) items[index].classList.remove('highlight');
            index = (index - 1 + items.length) % items.length;
        } else if (e.key === 'Enter') {
            if (index >= 0) items[index].click();
        } else if (e.key === 'Escape') {
            this.closeDropdown();
        }
        
        
        items[index].classList.add('highlight');
        items[index].scrollIntoView({
            block: "nearest", // Keeps it in view without jumping
            inline: "nearest"
        });

        this.selectOption(this.filteredOptions[index], false);
    }
    
    destroy() {
        // Remove event listeners
        this.input.removeEventListener("focus", this.boundRenderOptions);
        this.input.removeEventListener("input", this.boundFilterOptions);
        this.input.removeEventListener("keydown", this.boundHandleKeydown);

        this.clearButton.removeEventListener("click", this.boundClear);

        document.removeEventListener("click", this.boundHandleOutsideClick);

        // Remove all options
        this.optionsContainer.innerHTML = "";

        // Clear references
        this.container = null;
        this.input = null;
        this.optionsContainer = null;
        this.clearButton = null;
        this.options = null;
        this.filteredOptions = null;
        this.selectedOption = null;
    }
}

// populate stores dropdown
document.addEventListener('DOMContentLoaded', function () {
    fetch('https://sonae-services.production.theloop.tech/forms/prints/details', {
      headers: {
        Client: 'note_forms',
        Authorization: 's6498+4qekeJFwTpZnUtOyaVbVR2CZkSa/h1Xzjj+XK0YZ/o+dKOd848hjR5Xiu/nNcGzpHGNOmFhi++J/fVGTZVQouI4vp+ONh8AYTLlCz293bdS0SQpVSdFFVTVFqv'
      }
    })
      .then((response) => response.json())
      .then((data) => {
        const hubSelect = document.querySelector('#autocomplete-input');
        
        if (hubSelect) {
            const container = document.getElementById("autocomplete-container");
            const input = document.getElementById("autocomplete-input");
            const optionsContainer = document.getElementById("autocomplete-options-container");
            const clearButton = document.getElementById("autocomplete-clear-button");

            const options = data?.hubs?.map(hub => ({
                label: hub.name,
                value: hub.id,
            })) || [];

            // sort options alphabetically
            options.sort((a, b) => a.label.localeCompare(b.label));

            new Autocomplete(container, input, optionsContainer, clearButton, options);
        }
      })
      .catch((error) => console.error('Error fetching data:', error));
});

// page change
const togglePages = (showFirst) => {
    firstPage.classList.toggle("element--display-none", !showFirst);
    secondPage.classList.toggle("element--display-none", showFirst);
};

impressoesForm?.querySelector("#nextPage")?.addEventListener("click", (e) => {
    e.preventDefault();
    
    const isValid = validateFirstPage();
    
    if (!isValid) {
        return;
    }

    togglePages(false);

    window.scrollTo({ top: 0, behavior: "smooth" });

    // adjust timeline component
    impressoesForm.querySelector(".timeline-progress")?.setAttribute("style", "height: 100%");
    impressoesForm.querySelector(".timeline-current")?.setAttribute("style", "display: none");
    impressoesForm.querySelector(".timeline-end")?.setAttribute("style", "background-color: #306ABF");
});

impressoesForm?.querySelector("#previousPage")?.addEventListener("click", (e) => {
    e.preventDefault();
    togglePages(true);
    document.querySelector(".star-2")?.scrollIntoView({ behavior: "smooth" });

    // adjust timeline component
    impressoesForm.querySelector(".timeline-progress")?.removeAttribute("style");
    impressoesForm.querySelector(".timeline-current")?.removeAttribute("style");
    impressoesForm.querySelector(".timeline-end")?.removeAttribute("style");
});

// validate first page
function validateFirstPage() {
    let isValid = true;

    // files
    const fileInput = impressoesForm?.querySelector("#files");

    const validateFiles = () => {
        const files = fileInput?.files;

        if (!files?.length) {
            isValid = false;
        }

        fileInput?.closest(".dropzone")?.classList.toggle("input-error", !files?.length);
    }

    validateFiles();

    // Add event listeners to validate on change or input
    if (!fileInput.dataset.listenerAdded) {
        fileInput?.addEventListener("change", () => {
            validateFiles();
        });

        fileInput?.addEventListener("input", () => {
            validateFiles();
        });

        fileInput.dataset.listenerAdded = "true"; // prevent duplicate listeners
    }

    // radio groups
    const radioGroupNames = [
        'print',
        'format',
        'paper_kind',
        'prints_per_page',
        'page_orientation',
        'extra_service',
    ];

    isValid = !radioGroupNames.map(name => validateRadioGroup(name))?.some(result => !result) && isValid;

    return isValid;
}

function validateRadioGroup(name) {
    const isValid = impressoesForm?.querySelector(`input[name='${name}']:checked`);
    const container = impressoesForm
        ?.querySelector(`input[name='${name}']`)
        ?.closest(".prints-input-container")

    // toggle the error state    
    container?.classList.toggle("input-error", !isValid);

    if (!container.dataset.listenerAdded) {
        container.addEventListener("click", () => {
            validateRadioGroup(name);
        });

        container.dataset.listenerAdded = "true"; // prevent duplicate listeners
    }

    return isValid;
}

function validateInput(input) {
    const isInvalid = !input.value || !input.checkValidity();
    input.classList.toggle("input-error", isInvalid);
    return isInvalid;
};

function validateSecondPage() {
    const fields = ["name", "surname", "email", "phone"];
    let isValid = true;

    fields.forEach((field) => {
        const input = impressoesForm.querySelector(`[name='${field}']`);
        if (!input) return;

        if (validateInput(input)) isValid = false;

        // attach event listener once per field
        if (!input.dataset.listenerAdded) {
            input.addEventListener("focusout", () => validateInput(input));
            input.dataset.listenerAdded = "true"; // prevent duplicate listeners
        }
    });

    // validate hub_id
    const input = impressoesForm.querySelector(`[name='hub_id']`);

    if (!input) return;

    if (!input.dataset.value) {
        input.classList.toggle("input-error", true);
        isValid = false;
    } else {
        input.classList.toggle("input-error", false);
    }

    return isValid;
}

// form submit
impressoesForm?.addEventListener("submit", async (e) => {
    e.preventDefault();

    const formModal = document.querySelector("#impressoes-popup");
    const modalText = formModal.querySelector(".modal-heading__text span");

    try {
        const impressoesFormData = new FormData(impressoesForm);
        let isValid = validateFirstPage() && validateSecondPage();

        if (!isValid) {
            return;
        }

        // ensure radio button values are captured
        impressoesForm.querySelectorAll("input[type='radio']:checked").forEach(radio => {
            impressoesFormData.set(radio.name, radio.value);
        });

        // Ensure number input values are captured
        impressoesFormData.set("number_of_copies", impressoesForm.querySelector("#number_of_copies")?.value);

        impressoesFormData.set("hub_id", impressoesForm.querySelector("[name='hub_id']")?.dataset?.value);

        const printRes = await fetch('https://sonae-services.production.theloop.tech/forms/prints', {
            method: "POST",
            body: impressoesFormData,
            headers: {
                Client: 'note_forms',
                Authorization: 's6498+4qekeJFwTpZnUtOyaVbVR2CZkSa/h1Xzjj+XK0YZ/o+dKOd848hjR5Xiu/nNcGzpHGNOmFhi++J/fVGTZVQouI4vp+ONh8AYTLlCz293bdS0SQpVSdFFVTVFqv',
            }
        })

        if (!printRes.ok) {
            const resError = await printRes.json();
            throw new Error(resError?.message || "Sorry an error occurred");
        }

        const resData = await printRes.json();

        if (resData){
            modalText.textContent = resData.message;

            formModal.show();

            setTimeout(() => {
                formModal.hide();
                location.assign(`/`);
            }, 2000);
        }
        
    } catch (error) {
        const errorMsg = error?.message;
        modalText.textContent = errorMsg;

        formModal.show();

        setTimeout(() => {
            formModal.hide();
        }, 2000);
    }
});

// custom dropzone
const dropzone = document.getElementById('dropzone');
const fileInput = document.getElementById('files');

dropzone.addEventListener('click', () => {
    fileInput.click();
});

dropzone.addEventListener('dragover', (e) => {
    e.preventDefault();
    dropzone.classList.add('dragover');
});

dropzone.addEventListener('dragleave', () => {
    dropzone.classList.remove('dragover');
});

dropzone.addEventListener('drop', (e) => {
    e.preventDefault();
    dropzone.classList.remove('dragover');
    const files = e.dataTransfer.files;
    fileInput.files = files; 
    fileInput.dispatchEvent(new Event("change"))
});

fileInput.addEventListener('change', (event) => {
    const files = Object.values(event.target?.files);

    if (!files.length) {
        return;
    }

    impressoesForm.querySelector("#file-list").innerHTML = files.map(file => file.name).join(", " || "Selecionar Ficheiro(s)")
});

// custom number input
let printsQuantityElement = document.getElementById('number_of_copies');

document.getElementById('prints-quantity-decrease-button').addEventListener('click', (e) => {
    e.preventDefault();

    if (printsQuantityElement.value === "1") {
        return ;
    }

    printsQuantityElement.value--;
})

document.getElementById('prints-quantity-increase-button').addEventListener('click', (e) => {
    e.preventDefault();
    printsQuantityElement.value++;
})

// custom radio buttons
document.querySelectorAll(".radio-container").forEach(container => {
    const radio = container.querySelector("input[type='radio']");
    const button = container.querySelector("button");
    const svg = button.querySelector("img");

    const toggleSelectedButton = () => {
        svg.classList.toggle("element--display-none", !radio.checked);
    };

    toggleSelectedButton();
    
    radio.addEventListener("change", toggleSelectedButton);
    
    button.addEventListener("click", (e) => { 
        e.preventDefault();

        if (!radio.checked) {
            Array.from(document.querySelectorAll(`input[name="${radio.name}"]`))
            .filter(r => r.id !== radio.id)
            .forEach(r => {
                r.checked = false;
                r.dispatchEvent(new Event("change"));
            });

            radio.checked = true;
        }

        radio.dispatchEvent(new Event("change"));
    });
});

// custom radio button
document.querySelectorAll(".radio-container").forEach(container => {
    const radio = container.querySelector("input[type='radio']");
    const label = container.querySelector(".radio-label");
    const button = container.querySelector("button");
    const svg = button.querySelector("img");

    const toggleSelectedButton = () => {
        svg.classList.toggle("element--display-none", !radio.checked);
    };

    toggleSelectedButton();
    
    radio.addEventListener("change", toggleSelectedButton);
    
    button.addEventListener("click", (e) => { 
        e.preventDefault();

        if (!radio.checked) {
            Array.from(document.querySelectorAll(`input[name="${radio.name}"]`))
            .filter(r => r.id !== radio.id)
            .forEach(r => {
                r.checked = false;
                r.dispatchEvent(new Event("change"));
            });

            radio.checked = true;
        }

        radio.dispatchEvent(new Event("change"));
    });    

    // change the default click on the label to force the same behavior
    label.addEventListener("click", (event) => {
        event.preventDefault();
        button.dispatchEvent(new Event("click"));
    });
});

// custom print type radio buttons    
const inputContainer = document.querySelector('fieldset[name="kind"]');
const radioButtons = inputContainer.querySelectorAll("input[type='radio']");
const buttons = inputContainer.querySelectorAll("button");

const toggleSelectedButton = () => {
    radioButtons.forEach((radio, index) => {
        buttons[index].classList.toggle("prints-type-option-checked", radio.checked);
    });
};

toggleSelectedButton();

radioButtons.forEach(radio => {
    radio.addEventListener("change", toggleSelectedButton);
});

buttons.forEach((button, index) => {
    button.addEventListener("click", (e) => {
        e.preventDefault();
        const radio = radioButtons[index];
        
        if (!radio.checked) {
            radioButtons.forEach(r => {
                r.checked = false;
                r.dispatchEvent(new Event("change"));
            });
            radio.checked = true;
        }

        radio.dispatchEvent(new Event("change"));
    });
});
